export default [

  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Error.vue`
    )
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Login.vue`
    )
  },
  {
    path: '/register',
    meta: {
      public: true,
    },
    name: 'Register',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Register.vue`
    )
  },
  {
    path: '/',
    meta: {},
    name: 'Root',
    redirect: {
      name: 'Dashboard'
    }
  },
  {
    path: '/dashboard',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'Dashboard',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Dashboard.vue`
    )
  },
  {
    path: '/profile',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'Profile',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Profile.vue`
    )
  },
  {
    path: '/appphoto',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'AppPhoto',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/AppPhoto.vue`
    )
  },
  {
    path: '/projects',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'widget-projects',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Projects.vue`
    )
  },
  {
    path: '/employees',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'Employees',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Employees.vue`
    )
  },

  {
    path: '/chat',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'widget-chat',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/components/chat/ChatLayout.vue`
    ),
    redirect: {
      path: '/chat/messaging'
    },
    children: [{
        path: '/chat/messaging/:uuid?',
        meta: {
          breadcrumb: true,
          requiresAuth: true
        },
        name: 'ChatMessaging',
        props: true,
        components: {
          default: () => import(
            `@/components/chat/ChatMessaging.vue`
          ),
        }
      },
      {
        path: '/chat/contact/:uuid?',
        meta: {
          breadcrumb: true,
          requiresAuth: true
        },
        name: 'ChatContact',
        components: {
          default: () => import(
            `@/components/chat/ChatContact.vue`
          ),

        }
      },
      {
        path: '/chat/friend/:uuid?',
        meta: {
          breadcrumb: true,
          requiresAuth: true
        },
        name: 'ChatFriend',
        components: {
          default: () => import(
            `@/components/chat/ChatFriend.vue`
          ),

        }
      }
    ]
  },


  

  
  {
    path: '/form/newmember',
    meta: {
      breadcrumb: false,
      requiresAuth: true
    },
    name: 'newmember',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/form/NewMember.vue`
    )
  },
  {
    path: '/forms/newproject',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'newproject',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/form/NewProject.vue`
    )
  },
  {
    path: '/modifiers/employeeprofile',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'employeeprofile',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/modifiers/EmployeeProfile.vue`
    )
  },
  {
    path: '/providers/vodaphone',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/providers-vodaphone',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/providers/Vodaphone.vue`
    )
  },
  {
    path: '/providers/orange-tigo',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/providers-orange_tigo',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/providers/OrangeTigo.vue`
    )
  },
  {
    path: '/providers/airtel',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/providers-airtel',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/providers/Airtel.vue`
    )
  },
  {
    path: '/providers/africell',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/providers-africell',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/providers/Africell.vue`
    )
  },
  {
    path: '/providers/others',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/providers-others',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/providers/Others.vue`
    )
  },
  {
    path: '/widgets/post',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'widget-post',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Post.vue`
    )
  },
  {
    path: '/widgets/statistic',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/statistic',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Statistic.vue`
    )
  },
  {
    path: '/widgets/allmembers',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/widget-allmembers',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/AllMembers.vue`
    )
  },
  {
    path: '/widgets/allusers',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/widget-allusers',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/AllUsers.vue`
    )
  },
  {
    path: '/widgets/allusers_ecc',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/widget-allusers_ecc',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/AllUsers_ecc.vue`
    )
  },
  {
    path: '/widgets/allusers_ecc_emp',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/widget-allusers_ecc_emp',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/AllUsers_ecc_emp.vue`
    )
  },
  {
    path: '/widgets/allusers_emp',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/widget-allusers_emp',
    component: () => import(
      `@/pages/widgets/AllUsers_emp.vue`
    )
  },
  {
    path: '/widgets/todayusers',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/widget-todayusers',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/TodayUsers.vue`
    )
  },

  {
    path: '/widgets/todayusers_ecc',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/widget-todayusers_ecc',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/TodayUsers_ecc.vue`
    )
  },

  {
    path: '/widgets/chart',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/chart',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Chart.vue`
    )
  },

  {
    path: '/widgets/empty-list',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/widget-empty-list',
    component: () => import(
   
      `@/pages/widgets/Emptylist.vue`
    )
  },
  {
    path: '/widgets/serviteurs',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/widget-serviteurs',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Serviteurs.vue`
    )
  },
  {
    path: '/widgets/massaga',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/widget-massaga',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Massaga.vue`
    )
  },
  {
    path: '/widgets/todaylist',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/widget-todaylist',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/TodayList.vue`
    )
  },
  {
    path: '/widgets/search',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/widget-search',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Search.vue`
    )
  },
  {
    path: '/widgets/referrals',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/widget-referrals',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Referrals.vue`
    )
  },
  {
    path: '/modifiers/editproject/:project_id',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/modifiers-editproject',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/modifiers/EditProject.vue`
    )
  },
  {
    path: '/modifiers/editjob/:job_id',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/modifiers-editjob',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/modifiers/EditJob.vue`
    )
  },
  {
    path: '/medias',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'widget-medias',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Medias.vue`
    )
  },
  {
    path: '/events',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'widget-events',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Events.vue`
    )
  },
  {
    path: '/modifiers/editmedia/:media_id',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/modifiers-editmedia',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/modifiers/EditMedia.vue`
    )
  },
  {
    path: '/modifiers/editmerchant/:merchant_id',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/modifiers-editmerchant',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/modifiers/EditMerchant.vue`
    )
  },

  {
    path: '/merchants',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'widget-merchants',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Merchants.vue`
    )
  },

  {
    path: '/modifiers/editcoupon/:coupon_id',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'components/modifiers-editcoupon',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/modifiers/EditCoupon.vue`
    )
  },
  {
    path: '/coupons',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'widget-coupons',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Coupons.vue`
    )
  },
  {
    path: '/kyc',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'widget-kyc',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Kyc.vue`
    )
  },
  {
    path: '/kyc_ecc',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'widget-kyc_ecc',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Kyc_ecc.vue`
    )
  },
  {
    path: '/prayers',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'widget-prayers',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Prayers.vue`
    )
  },
  {
    path: '/prayers_ecc',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'widget-prayers_ecc',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/Prayers_ecc.vue`
    )
  },
  {
    path: '/algolia',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'widget-algolia',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/widgets/algolia.vue`
    )
  },
  
];


// WEBPACK FOOTER //
// ./src/router/paths.js